import type { ClientDto } from '@fos/shared/contracts/crm';
import { cn } from '../../../lib/cn';
import {
  type ClientOverviewSection,
  getClientOverviewSections,
  registerClientOverviewSection,
  setClientTab,
} from '../slots';
import { ClientPortalSection } from './ClientPortalSection';
import { ContactsSection } from './ContactsSection';
import { ClientDocumentsShortcut, ClientDocumentsTab } from './documents/ClientDocumentsTab';

// Sekcja modułu klientów: „Kontakty” w prawej kolumnie, pod sekcjami innych modułów (np. „Otwarte zadania”).
registerClientOverviewSection({ key: 'contacts', column: 'right', order: 100, component: ContactsSection });
// „Portal klienta” (17.10.2026) pod kontaktami — tylko Właściciel i Admin (sekcja sama się ukrywa)
registerClientOverviewSection({ key: 'portal', column: 'right', order: 110, component: ClientPortalSection });
// „Dokumenty” (17.10.2026): zakładka modułu klientów; na telefonie (zakładki ukryte) wejście z Przeglądu nad kontaktami
setClientTab('documents', ClientDocumentsTab);
registerClientOverviewSection({ key: 'documents', column: 'right', order: 90, component: ClientDocumentsShortcut });

function Column({
  sections,
  client,
  className,
}: {
  sections: ClientOverviewSection[];
  client: ClientDto;
  className?: string;
}) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-4 md:gap-6', className)}>
      {sections.map(({ key, component: Section }) => (
        <Section key={key} client={client} />
      ))}
    </div>
  );
}

/**
 * Zakładka „Przegląd” profilu klienta (Figma 05 Klienci, profil REA): góra na pełną szerokość (baner, kafelki),
 * pod spodem dwie kolumny (lewa: projekty, usługi, serwer, „W skrócie”; prawa: otwarte zadania, kontakty).
 * Sekcje dokładają moduły przez `registerClientOverviewSection` (slots.tsx). Bez sekcji lewej kolumny prawa
 * zajmuje pierwszą połowę (nie zostawiamy pustej kolumny). Każda sekcja to biały blok (`ui/Section`, DECISIONS
 * 2026-10-07 „Nowy układ wizualny”); baner i kafelki u góry zostają na tle.
 */
export function ClientOverview({ client }: { client: ClientDto }) {
  const top = getClientOverviewSections('top');
  const left = getClientOverviewSections('left');
  const right = getClientOverviewSections('right');
  return (
    <div className="flex flex-col gap-4 md:gap-6">
      {top.length > 0 && <Column sections={top} client={client} />}
      {/* dwie kolumny od 1280 px (integracja Fali 9): sekcje mają własny padding 32 px, więc przy 1024 px kolumna
          miałaby ~280 px treści i nazwy zasobów i projektów znikały (e2e/fala1-uklad) — wcześniej próg 1024 px */}
      <div className="grid gap-4 md:gap-6 xl:grid-cols-2">
        {left.length > 0 && <Column sections={left} client={client} />}
        {/* mobile (Figma 05 mobile): otwarte zadania zaraz pod kafelkami */}
        <Column sections={right} client={client} className="order-first xl:order-none" />
      </div>
    </div>
  );
}
